export default Object.freeze({
  AWS: 'aws',
  AZURE: 'azure',
  GCP: 'gcp',
});
